import type { Supplier } from "@/models/supplier";

import axios from "axios";

export const getSuppliers = async (): Promise<Supplier[]> => {
  const resp = await axios.get<Supplier[]>("/api/suppliers");
  return resp.data;
};

export const uploadSuppliers = async (formData: FormData): Promise<void> => {
  await axios.post("/api/suppliers", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
